<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-06 15:57:42
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-30 19:53:52
 * @FilePath: /jy-dashboard-web/src/components/productionManagement/scx/chart-liquidfill.vue
 * @Description: 液体填充
-->
<template>
  <div :id="id">
    <div class="liquid" :class="[type]">
      <span class="value">{{ this.data }}</span>
    </div>
  </div>
</template>

<script>
import { Liquid } from '@antv/g2plot'
export default {
  props: {
    data: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      chart: null
    }
  },
  computed: {
    id () {
      return Math.random().toString(36)
    },
    percent () {
      return Number(this.data.split('%')[0]) * 0.01
    },
    type () {
      const num = Number(this.data.split('%')[0])
      if (num <= 25) {
        return 'fill-25'
      } else if (num <= 50) {
        return 'fill-50'
      } else if (num <= 75) {
        return 'fill-75'
      } else {
        return 'fill-100'
      }
    }
  },
  methods: {
    initChart () {
      this.chart = new Liquid(this.id, {
        percent: this.percent,
        width: 78,
        height: 78,
        autoFit: false,
        padding: 0,
        radius: 1,
        color: '#37B5CE',
        outline: {
          border: 2,
          distance: 0
        },
        wave: {
          length: 64,
          count: 3
        },
        statistic: {
          content: {
            style: ({ percent }) => ({
              fontSize: 18,
              lineHeight: 1,
              fill: '#EDFEFF'
            }),
            formatter: () => {
              return this.data
            }
          }
        }
      })
      this.chart.render()
    }
  },
  mounted () {
    // this.initChart()
  }
}
</script>

<style lang="scss">
.liquid {
  width: 78px;
  height: 77px;
  background-size: cover;
  position: relative;
  .value {
    display: block;
    position: absolute;
    top: 24px;
    width: 100%;
    text-align: center;
    font-size: 22px;
    font-family: Bahnschrift;
    font-weight: 400;
    color: #edfeff;
  }
}
.fill-25 {
  background-image: url("/public/image/production-management/icon/生产进度1@2x.png");
}
.fill-50 {
  background-image: url("/public/image/production-management/icon/生产进度2@2x.png");
}
.fill-75 {
  background-image: url("/public/image/production-management/icon/生产进度3@2x.png");
}
.fill-100 {
  background-image: url("/public/image/production-management/icon/生产进度4@2x.png");
}
</style>
